/**
 * product-price-deal.js
 * Bloc prix de la fiche et footer sticky mobile : recalcule au changement de variante ce que
 * theme.js ignore — pastille %, « Économisez », Prix MINT et état bon plan.
 * Même règle que snippets/price-deal.liquid : les modifier ensemble.
 * Le prix et le prix neuf restent écrits par theme.js (updatePrice) et par product-template.liquid.
 */
(function () {
  // Le bloc prix peut être rendu deux fois : un seul jeu d'écouteurs.
  if (window.mbPriceDealReady) return;
  window.mbPriceDealReady = true;

  // Même rendu que le filtre Liquid `money` du thème : sans centimes nuls.
  function formatMoney(cents) {
    return theme.Currency.formatMoney(cents, theme.settings.moneyFormat).replace(/,00(?=\s*€)/, '');
  }

  function computeDeal(root, variant) {
    var price = variant.price;
    var compare = variant.compare_at_price > price ? variant.compare_at_price : 0;
    var mint = parseInt(root.getAttribute('data-mint-cents'), 10) || 0;
    // Prix avant remise égal au prix neuf : pas de baisse de prix (même règle que le Liquid).
    var bonPlan = mint > price && mint !== variant.compare_at_price;
    var showMint = bonPlan && (!compare || mint < compare);
    var ref = compare || (bonPlan ? mint : 0);
    var savings = ref ? ref - price : 0;
    return {
      hasCompare: compare > 0,
      bonPlan: bonPlan,
      showMint: showMint,
      savings: savings,
      pct: ref ? Math.round((savings * 100) / ref) : 0,
    };
  }

  function render(root, deal) {
    var dealClass = root.getAttribute('data-deal-class');
    if (dealClass) root.classList.toggle(dealClass, deal.bonPlan);
    if (root.hasAttribute('data-cta-placement')) {
      root.setAttribute('data-cta-placement', deal.bonPlan ? 'bon_plan' : 'standard');
    }
    var pctEl = root.querySelector('[data-deal-pct]');
    if (pctEl) {
      pctEl.hidden = !deal.pct;
      pctEl.textContent = '−' + deal.pct + '%';
    }
    var savingsEl = root.querySelector('[data-deal-savings]');
    if (savingsEl) savingsEl.hidden = !deal.savings;
    var savingsAmountEl = root.querySelector('[data-deal-savings-amount]');
    if (savingsAmountEl) savingsAmountEl.textContent = formatMoney(deal.savings);
    var mintEl = root.querySelector('[data-deal-mint]');
    if (mintEl) mintEl.hidden = !deal.showMint;
    var compareA11y = root.querySelector('[data-compare-price-a11y]');
    // theme.js réécrit ce libellé d'après le seul prix neuf, juste après variant:change.
    if (compareA11y) {
      queueMicrotask(function () {
        compareA11y.setAttribute('aria-hidden', String(!(deal.hasCompare || deal.showMint)));
      });
    }
  }

  // variant:change est émis aussi par l'aperçu rapide d'un autre produit : chaque zone ne
  // réagit qu'aux variantes de son produit (même garde que delivery-date-core.liquid).
  function ownsVariant(root, variant) {
    var ids = (root.getAttribute('data-variant-ids') || '').split(',');
    return ids.indexOf(String(variant.id)) !== -1;
  }

  document.addEventListener('variant:change', function (e) {
    var variant = e && e.detail && e.detail.variant;
    if (!variant || !variant.id) return;
    // Relu à chaque changement : l'éditeur de thème peut avoir rendu la section à nouveau.
    document.querySelectorAll('[data-price-deal]').forEach(function (root) {
      if (ownsVariant(root, variant)) render(root, computeDeal(root, variant));
    });
  });
})();
